'use client';
import Button from './Button';
import {MAX_BULK_DECKS} from '@/lib/library-selection';

export default function LibrarySelectionActions({count,onMove,onDelete,onClear}:{count:number;onMove:()=>void;onDelete:()=>void;onClear:()=>void}) {
  const disabled=count===0;
  return <div className="flex w-full items-center justify-between gap-2">
    <div className="flex shrink-0 items-center gap-0.5">
      <Button variant="ghost" className="library-action" disabled={disabled} onClick={onMove}>
        <svg aria-hidden="true" className="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M3 7V5h6l2 3h10v11H3V7 M9 13h7m-3-3 3 3-3 3"/></svg>Move
      </Button>
      <Button variant="ghost" className="library-action" disabled={disabled} onClick={onDelete}>
        <svg aria-hidden="true" className="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M4 6h16M9 6V3h6v3M6 6l1 15h10l1-15M10 10v7m4-7v7"/></svg>Delete
      </Button>
      <Button variant="ghost" className="library-action" disabled={disabled} onClick={onClear} aria-label="Clear selection" title="Clear selection">
        <svg aria-hidden="true" className="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"><path d="m7 7 10 10M17 7 7 17"/></svg><span className="hidden sm:inline">Clear</span>
      </Button>
    </div>
    <span role="status" className="shrink-0 whitespace-nowrap text-xs tabular-nums text-muted" title={`Select up to ${MAX_BULK_DECKS} decks per action`}>{count} selected</span>
  </div>;
}
